import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullScreen = false }) => {
  const containerClass = fullScreen ? 'loading-spinner-container full-screen' : 'loading-spinner-container';
  
  return (
    <div className={containerClass}>
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 